import React, { useMemo } from 'react';
import formatMoney from '@/lib/formatMoney';
import Badge from '../UI/Badge';

export default function TradeLog({ trades, bars, playbackIndex }) {
  const visibleTrades = useMemo(() => {
    if (!trades) return [];
    const list = playbackIndex != null
      ? trades.filter((t) => t.barIndex <= playbackIndex)
      : trades;

    let cumPnL = 0;
    return list.map((t) => {
      cumPnL += t.realizedPnL || 0;
      const bar = bars && bars[t.barIndex];
      return {
        ...t,
        cumulativePnL: Math.round(cumPnL * 100) / 100,
        timestamp: bar?.timestamp || null,
      };
    }).reverse(); // newest first
  }, [trades, bars, playbackIndex]);

  if (visibleTrades.length === 0) {
    return <div className="text-center py-8 text-muted-foreground text-sm">No trades yet</div>;
  }

  return (
    <div className="flex-1 overflow-y-auto space-y-0.5">
      <p className="text-[10px] uppercase tracking-wider text-muted-foreground/60 mb-1.5 px-1">
        {visibleTrades.length} trades
      </p>
      {visibleTrades.map((t, i) => (
        <div
          key={`${t.barIndex}-${t.side}-${i}`}
          className="flex items-center justify-between text-xs px-2 py-1.5 rounded hover:bg-accent/10 transition-colors"
        >
          <div className="flex items-center gap-2 min-w-0">
            <Badge variant={t.side === 'buy' ? 'success' : 'danger'} className="text-[10px] px-1 py-0 flex-shrink-0">
              {t.side.toUpperCase()}
            </Badge>
            <span className="text-muted-foreground truncate">
              {parseFloat(t.quantity).toFixed(2)} @ {formatMoney(t.price)}
            </span>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            {t.realizedPnL !== 0 && (
              <span className={`font-mono text-[11px] ${t.realizedPnL > 0 ? 'text-green-400' : 'text-red-400'}`}>
                {formatMoney(t.realizedPnL, { sign: true })}
              </span>
            )}
            <span className={`font-mono text-[10px] ${t.cumulativePnL >= 0 ? 'text-green-400/60' : 'text-red-400/60'}`}>
              ({t.cumulativePnL >= 0 ? '+' : ''}{t.cumulativePnL.toFixed(0)})
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
